// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
require('./dms.scss');

const deps = [
  'bench.main-app',
  require('angular-ui-router'),
  require('./statements').name,
  require('./receipt').name,
  require('./tax').name,
  require('./exports').name,
  require('./other').name,
  require('./internal').name,
  require('./addons').name,
  require('data/collection/document').name,
  require('data/collection/ledger').name,
];

module.exports = angular
  .module('bench.app.mainapp.dms', deps)

  .config(($stateProvider, $urlRouterProvider, MainAppConfig) => {
    const baseUrl = `/app/${MainAppConfig.clientId}`;
    const stateName = 'bench.dms';
    const path = MainAppConfig.routes[stateName];

    $stateProvider.state(stateName, {
      abstract: true,
      url: path,
      template: require('./dms.html'),
      controllerAs: 'vm',
      controller($state) {
        this.state = () => $state.current.name.split('.')[2];
        this.$stateParams = $state.params;
        return this;
      },
    });

    return $urlRouterProvider.when(`${baseUrl}${path}`, `${baseUrl}${path}/statements/ledger/all/`);
  });
